import { useDeleteUser, useUpdateStatus } from "@/hooks/useUsers";
import { L } from "@/i18n";
import { ConfirmDialog } from "./ConfirmDialog";

const STATUS_COPY = {
  approved: [["Approve user?", "Aprovar utilizador?"], ["The user will get access to the platform.", "O utilizador passa a ter acesso à plataforma."], ["Approve", "Aprovar"]],
  rejected: [["Reject user?", "Rejeitar utilizador?"], ["The registration request will be marked as rejected.", "O pedido de registo será marcado como rejeitado."], ["Reject", "Rejeitar"]],
  blocked: [["Block user?", "Bloquear utilizador?"], ["The user will no longer be able to access the platform.", "O utilizador deixa de conseguir aceder à plataforma."], ["Block", "Bloquear"]],
};

const DELETE_COPY = [
  ["Delete user?", "Eliminar utilizador?"],
  ["This action is permanent: it deletes the account and ALL associated data (progress, exams, history).", "Esta ação é permanente: apaga a conta e TODOS os dados associados (progresso, exames, histórico)."],
  ["Delete", "Eliminar"],
];

export const UserConfirm = ({ request, onClose }) => {
  const updateStatus = useUpdateStatus();
  const deleteUser = useDeleteUser();
  const u = request?.user;
  const isDelete = request?.type === "delete";
  const [title, desc, label] = (isDelete ? DELETE_COPY : STATUS_COPY[request?.status] ?? [[""], [""], [""]]).map(([en, pt]) => L(en, pt));

  const confirm = () => {
    const vars = { id: u.id, username: u.username, status: request.status };
    const m = isDelete ? deleteUser : updateStatus;
    m.mutate(vars, { onSettled: onClose });
  };

  return (
    <ConfirmDialog
      open={!!request}
      onOpenChange={(o) => !o && onClose()}
      title={title}
      description={u ? <><b className="text-slate-200">{u.username}</b> ({u.email}). {desc}</> : ""}
      confirmLabel={label}
      danger={isDelete || request?.status === "blocked"}
      loading={updateStatus.isPending || deleteUser.isPending}
      onConfirm={confirm}
    />
  );
};
